import useLazyQuery from "../useLazyQuery"

export const useRefreshKeycardDoorsQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/keycard-doors/refresh`
	return useLazyQuery<void, void>(url, "POST", true)
}
